function requireAll(r) {
  r.keys().forEach(r);
}
requireAll(require.context('./icons/', true, /\.svg$/));
requireAll(require.context('./images/', true));

// CSS
import './css/meanmenu.min.css';
import 'jquery-nice-select/css/nice-select.css';
import './scss/style.scss';

// JS
import './js/jquery.meanmenu.min.js';
import './js/jquery.nice-select.min.js';
import './js/vigi.js';
$(document).ready(function () {
  $('.is-select').niceSelect();
  $('.menu-responsive').meanmenu({
    meanMenuContainer: '.responsive-menu',
    meanScreenWidth: '991',
    meanMenuOpen: '<span></span><span></span><span></span>',
    meanMenuClose: '<span></span><span></span><span></span>'
  });
});
$(window).on('scroll', function () {
  var scrollDown = $(window).scrollTop();
  if (scrollDown < 135) {
    $(".header__sticky").removeClass("header__sticky-sticky-menu");
  } else {
    $(".header__sticky").addClass("header__sticky-sticky-menu");
  }
});